module.exports = __webpack_public_path__ + "img/icons8-parking.76f322b1.svg";